export const articles = [
  // 1. Artikel kryesore
  {
    id: 'bestimmter-artikel',
    category: 'artikel',
    level: 'A1',
    title: 'Bestimmter Artikel (Nyja e Shquar: der, die, das)',
    detailedContent: `
      <section>
        <p><b>Nyjet e Shquara (Bestimmter Artikel)</b> tregojnë objekte ose persona konkretë, specifikë dh të PËRCAKTUAR e PËRMENDUR MË PARË. Ekuivalente n'shqip me prapashtesat (i/e atij/asaj/tyre).</p>
        
        <h3>Kur përdoret "der", "die", ose "das"?</h3>
        <ul>
          <li><b>Me gjëra tashmë të njohura:</b> <i>Wo ist <b>das</b> Buch?</i> (Ku është libri? - libri që ne e dimë cili).</li>
          <li><b>Gjëra unike në botë:</b> <i><b>Die</b> Sonne ist groß.</i> (Dielli është i madh).</li>
          <li><b>Emra lumenjsh / institucionesh Thelbësore:</b> <i><b>Der</b> Rhein, <b>die</b> Alpen.</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Die Lehrerin kommt ins Klassenzimmer.', alb: 'Mësuesja po vjen në klasë. (Mësuesja specifike e asajt klase -> Die).' }
    ],
    exercises: []
  },
  {
    id: 'unbestimmter-artikel',
    category: 'artikel',
    level: 'A1',
    title: 'Unbestimmter Artikel (Nyja e Pashquar: ein, eine)',
    detailedContent: `
      <section>
        <p><b>Nyjet e Pashquara (Unbestimmter Artikel)</b> tregojnë sasi t "Një" / diçka e pafokusuar, e papërmendur asnjëher më përpara ose krejtësisht e përgjithshme thelbësore ("njëlloj").</p>
        
        <h3>Përdorimet:</h3>
        <ul>
          <li><b>Diçkaje për herë të parë zë:</b> <i>Ich sehe <b>einen</b> Hund. <b>Der</b> Hund ist Schwarz.</i> (Rregulli i artë i letërsisë. Fjala hy e pashquar me "ein" - dhe vazhdon në jetën thelb shquar me "der").</li>
          <li><b>Identifikime kualitative:</b> <i>Das ist <b>ein</b> Auto.</i> (Kjo është NJË makinë - thelbsoresh jo helikopter rrmbyeshvtem).</li>
        </ul>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Kujdes Shumësin!</strong> "ein/eine" përkthehen t "NJË" thellsisht në numër. Ndaj ATO NUK EKZISTOJNË KURRË NË SHUMËS.  <br>Njëjës: <i>Das ist <b>ein</b> Bild</i>. <br>Shumës: <i>Das sind <b>Bilder</b></i> (pjesa "Një" hidhet tutje the mbetet asgje (Nullartikel)).
        </div>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: [
      { question: 'Pse s\'themë "Anna hat eine Kinder?"', options: ['Sepse Kinder asht shumes dhe s\'kem nji fmi per shumes. Flitet per thelbin 0/Shumes(Zero Artikel)', 'Qka gabim me te rrethanoreve'], correct: 0, explanation: 'Eine flet pë "Një", nuk mund të thesh "Ana ka një fëmijët". Mbetet vetëm -Anna hat Kinder-' }
    ]
  },
  {
    id: 'nullartikel',
    category: 'artikel',
    level: 'A1',
    title: 'Nullartikel (Kur fjalët S\'KANË NYJE)',
    detailedContent: `
      <section>
        <p>Quhet <b>Zero-Artikull</b> dhe shfaqet atëherë kur ne Fjalitët nuk vihet Thelbesore nyje der/die/das E as ein/eine poshtërisht.</p>

        <h3>Aplikimi:</h3>
        <ul>
          <li><b>Shumësi i nyjeve t pashquara:</b> <i>Er isst Äpfel. (Ai ha mollë. Jo *nje moll, as *ato mollet* Thelbesisht molle).</i></li>
          <li><b>Emrat propër the llojet shteti/qyteti:</b> <i>Er kommt aus <b>Deutschland</b>. Ich bin in <b>Berlin</b>.</i> (Por Kujdes me përjeshtimet thellë formale Thelb "die Schweiz, die Türkei, der Irak").</li>
          <li><b>Profesionet (pasi foljeve *sein* dhe *werden*):</b> <i>Ich bin <b>Lehrer</b>. Sie wird <b>Ärztin</b>.</i> (Teorikisht e ndaluar gjermai me thene "ich bin ein Lehrer" thelb formale. - Kjo sdo me thene q t'kam nji! - une JAM thelbi mësues).</li>
          <li><b>Lëndët material the lëngje/gaze/pasaktsore (jo masë specifike njësie):</b> <i>Ich brauche <b>Wasser</b>. Er hat <b>Geld</b>.</i></li>
          <li><b>Thëniet abstracte ose gjendje panumureti (Ndjenja, uri, thelb t nxehte):</b> <i>Ich habe <b>Mitleid</b>. Wir haben <b>Hunger</b>.</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'negationsartikel',
    category: 'artikel',
    level: 'A1',
    title: 'Negationsartikel (Mohimi mbajtës: "kein")',
    detailedContent: `
      <section>
        <p>Gjermanishtja ka dy mënyra për të thënë "JO": i theksuari i thejsht <b>"nicht"</b> (për t mohu foljet tona e mbiemrat) dhe i quajtur-a nyje <b>"kein"</b> (ASNJË).</p>
        
        <h3>Kur përdoret "kein"?</h3>
        <p>Ajo thjesht merr vendin e fjalës "ein/eine/einen" t'nyjeve T pashquara the i shton një germë Thelb k- përpara! Formon zëvendsem i plot mohimit të saj të "një"-shit.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli Praktik:</strong> Nëse në thelb fjalia pa mohum mban fjala "EIN...", atehër ty duhet d t Përdorsh fjalen KEIN për e mohum at. <br>Por nwse do tvije NYJE E SHQUAR Thelb (der/die/das), t'pritet thelb "NICHT". <br><i>Das ist <b>ein</b> Auto. -> Das ist <b>kein</b> Auto.</i> <br><i>Das ist <b>das</b> Auto -> Das ist <b>nicht das</b> Auto.</i>
        </div>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },

  // Artikel në raste
  {
    id: 'artikel-nominativ',
    category: 'artikel',
    level: 'A1',
    title: 'Deklinimi thelbësor në Nominativ',
    detailedContent: `
      <section>
        <p>Për ta paraqitur qartë funksion të gjitha nyjeve që mësuam më siper, lëshohemi tabelen bashlidhëse rrethanerore. Nominativ shërben si subjekti kryesor në fjalit.</p>
      </section>
    `,
    tables: [
      {
        label: 'Nominativ (Subjekti - Kush / Çfarë?)',
        headers: ['Gjinia', 'Bestimmt (E shquar)', 'Unbestimmt (Pashquar)', 'Negation (Mohues)'],
        rows: [
          ['Maskulin', 'der', 'ein', 'kein'],
          ['Feminin', 'die', 'eine', 'keine'],
          ['Neutral', 'das', 'ein', 'kein'],
          ['Plural', 'die', 'NULL (asgje)', 'keine']
        ]
      }
    ],
    examples: [],
    exercises: []
  },
  {
    id: 'artikel-akkusativ',
    category: 'artikel',
    level: 'A2',
    title: 'Deklinimi thelbësor në Akkusativ',
    detailedContent: `
      <section>
        <p>Në Akkusativ, gjenesisht ndodh një ndryshues të vetëm, por dramatik: MASHKULLORJA ZËVENDËM FUNDOJEN "R" për të t'u theksuar me "N". Ky quhet thelbi i Objektivës Drejtpërtërdrejtshme.</p>
      </section>
    `,
    tables: [
      {
        label: 'Akkusativ (Objekti Thelb, Kë? Çfarë? Wohin?)',
        headers: ['Gjinia', 'Bestimmt (E shquar)', 'Unbestimmt (Pashquar)', 'Negation (Mohues)'],
        rows: [
          ['Maskulin', '<b>den</b>', '<b>einen</b>', '<b>keinen</b>'],
          ['Feminin', 'die (I pandryshur)', 'eine', 'keine'],
          ['Neutral', 'das (I pandryshue)', 'ein', 'kein'],
          ['Plural', 'die', 'NULL', 'keine']
        ]
      }
    ],
    exercises: [
      { question: 'Plotësoni thelbin: "Ich suche (kërkoj - akk) _____ Regenschirm (der)".', options: ['den / einen'], correct: 0, explanation: 'Fjala e bazës maskulines der Regenschirm thelbndërrohet nw den apo einen nw akuzativ thelb.' }
    ]
  },
  {
    id: 'artikel-dativ',
    category: 'artikel',
    level: 'A2',
    title: 'Deklinimi thelbësor në Dativ',
    detailedContent: `
      <section>
        <p>Të tërave u bien gëmat, Dativ i shendërron krejt dhe u jep mburrjes rrenjësore. (A mbajn thelb -m veshje mashku/asnju apo -r per fekra). Thelbi statik e pronnor pasive.</p>
      </section>
    `,
    tables: [
      {
        label: 'Dativ (Objekti indirekt, KU? KUJT?)',
        headers: ['Gjinia', 'Bestimmt (E shquar)', 'Unbestimmt (Pashquar)'],
        rows: [
          ['Maskulin', 'dem', 'einem'],
          ['Feminin', 'der', 'einer'],
          ['Neutral', 'dem', 'einem'],
          ['Plural', 'den <b>(+ Emrit i vihet n/en mbrapa)</b>', 'NULL (Emrit + n/en)']
        ]
      }
    ],
    exercises: []
  },
  {
    id: 'artikel-genitiv',
    category: 'artikel',
    level: 'B1',
    title: 'Deklinimi thelbësor në Genitiv',
    detailedContent: `
      <section>
        <p>Pronësirat letrarisht të pastra fjetoreve (I / e Kujt).</p>
      </section>
    `,
    tables: [
      {
        label: 'Genitiv (I / E Kujt?)',
        headers: ['Gjinia', 'Bestimmt (E shquar)', 'Unbestimmt (Pashquar)'],
        rows: [
          ['Maskulin', 'des <b>(+ Emrit i vihet -s/es)</b>', 'eines <b>(+ Emrit i vihet -s/es)</b>'],
          ['Feminin', 'der', 'einer'],
          ['Neutral', 'des <b>(+ Emrit i vihet -s/es)</b>', 'eines <b>(+ Emrit i vihet -s/es)</b>'],
          ['Plural', 'der', 'NULL']
        ]
      }
    ],
    exercises: []
  }
];
